/**
 * Обработчики звука, работающие в аудио-потоке браузера.
 *
 * Код лежит строками, потому что AudioWorklet грузится только по адресу
 * и исполняется в отдельном потоке — импортировать его как модуль
 * нельзя. Строки превращаются в blob-адрес при запуске звонка.
 *
 * Почему вообще worklet, а не ScriptProcessorNode: последний работает в
 * основном потоке, и любая перерисовка страницы даёт щелчок в звуке.
 * Здесь щелчок означает пропущенный кадр разговора.
 */

/** Захват микрофона: отдаёт блоки как есть, нарезка на кадры выше. */
export const CAPTURE_WORKLET = `
class Capture extends AudioWorkletProcessor {
  process(inputs) {
    const ch = inputs[0] && inputs[0][0];
    if (ch) this.port.postMessage(ch.slice(0));
    return true;
  }
}
registerProcessor('capture', Capture);
`

/**
 * Воспроизведение с очередью.
 *
 * Команда clear — это перебивание: всё, что уже налито в буфер,
 * собеседник слышать не должен. Без неё агент продолжает договаривать
 * реплику ещё секунду после того, как его перебили, и разговор
 * рассыпается.
 */
export const PLAYBACK_WORKLET = `
class Playback extends AudioWorkletProcessor {
  constructor() {
    super();
    this.queue = [];
    this.offset = 0;
    this.level = 0;
    this.port.onmessage = e => {
      if (e.data === 'clear') { this.queue = []; this.offset = 0; return; }
      this.queue.push(e.data);
    };
  }

  process(inputs, outputs) {
    const out = outputs[0][0];
    let peak = 0;

    for (let i = 0; i < out.length; i++) {
      if (!this.queue.length) { out[i] = 0; continue; }
      const buf = this.queue[0];
      const v = buf[this.offset++];
      out[i] = v;
      const abs = v < 0 ? -v : v;
      if (abs > peak) peak = abs;
      if (this.offset >= buf.length) { this.queue.shift(); this.offset = 0; }
    }

    // Громкость наружу — для пульсации на странице. Раз в 128 кадров,
    // а не на каждый: сообщения в основной поток стоят дороже самого
    // измерения.
    this.level = peak;
    if ((currentFrame % 1024) === 0) this.port.postMessage(peak);

    return true;
  }
}
registerProcessor('playback', Playback);
`

export function workletURL(code: string): string {
  return URL.createObjectURL(new Blob([code], { type: 'application/javascript' }))
}
